import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_CREATE_VALID_CEQ_TEST_DATES_URL} from '../../constants/apiUrls';
import {GenericErrorResponse, KeyValueResponse} from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CreateValidCeqTestDateModelRequest {
  registrationExamLevelUuid: string;
  admissionYear: number;
  firstAcceptedCeqTestDate: string;
  lastAcceptedCeqTestDate: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: KeyValueResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateValidCeqTestDates = ({onSuccess, onError}: Input) => {
  const postCreateValidCeqTestDates = async (payload: CreateValidCeqTestDateModelRequest) => {
    const res = await axiosClient.post<KeyValueResponse[]>(
        POST_CREATE_VALID_CEQ_TEST_DATES_URL,
        payload
    );
    return res.data;
  };

  return useCustomMutation(postCreateValidCeqTestDates, {
    onSuccess,
    onError,
  });
};
